<template>
  <transition name="transition-wait">
    <div class="LKPublicationsFormdataModalContainer">
      <div
        class="modal--names-mask LKPublicationsFormdataModalContainer__mask"
        @click="$emit('close')"
      />

      <div
        :class="contentClass"
        class="LKPublicationsFormdataModalContainer__container"
      >
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LKPublicationsFormdataModalContainer',
  props: {
    contentClass: null,
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.$emit('close')
      },
    },
  },
  mounted() {
    // from https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
    this.scrollY = window.scrollY
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
  },
  beforeDestroy() {
    document.body.style.top = ''
    document.body.style.position = ''
    document.body.style.width = ''
    window.scrollTo(0, parseInt(this.scrollY || 0, 10))
  },
}
</script>

<style lang="scss">

$duration: 0.3s;

.LKPublicationsFormdataModalContainer {
  position: fixed;
  top: 0%;
  right: 0%;
  bottom: 0%;
  left: 0%;
  z-index: 5;
  display: block !important;

  &__mask {
    position: fixed;
    top: 0%;
    right: 0%;
    bottom: 0%;
    left: 0%;
    cursor: default;
    background-color: $webflow-color-grey-opacity;
    animation: animation-opacity $duration;

    .transition-wait-leave-to & {
      animation: animation-opacity-reverse $duration ease-in;
    }
  }

  &__container {
    width: auto;
    animation: animation-up $duration;

    .transition-wait-leave-to & {
      animation: animation-up-reverse $duration ease-out;
    }
  }
}

@keyframes animation-opacity {
  from {
    opacity: 0;
  }
}

@keyframes animation-opacity-reverse {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes animation-up {
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    //
  }
}

@keyframes animation-up-reverse {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(100%);
  }
}

.transition-wait {
  &-enter-active,
  &-leave-active {
    transition: opacity ($duration - 0.1);
  }
}
</style>
